import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ba11fa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "rightTitle" }



  
export default /*#__PURE__*/_defineComponent({
  __name: 'RightTitle',
  props: ['title'],
  setup(__props) {

const props = __props;

  


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(props).title), 1))
}
}

})